export default {"src":"/_next/static/media/business-loan-key-feayures.1b4fe2f0.svg","height":500,"width":500};